// Submodule of user module

import { getField, updateField } from "vuex-map-fields";
import { SEARCH, FETCH, RESET_SEARCH } from "@/store/action-types";
import { RESET_STATE, TOGGLE_LOADING } from "@/store/mutation-types";

const getDefaultState = () => ({
  loading: false,
  query: null,
  active: null,
  locked: null,
  equipe: null,
  statut: null,
  options: {
    sortBy: ["id"],
    sortDesc: [false]
  }
});

const actions = {
  async [SEARCH]({ dispatch, state, commit }) {
    commit(TOGGLE_LOADING, true);

    if (state.query != null && state.query.length >= 1) {
      await dispatch(`notifications/${FETCH}`, { reset: true }, { root: true });
    } else {
      await dispatch(`notifications/${FETCH}`, { reset: true }, { root: true });
    }

    commit(TOGGLE_LOADING, false);
  },
  [RESET_SEARCH]({ dispatch, commit }) {
    commit(RESET_STATE);
    dispatch(`notifications/${FETCH}`, { reset: true }, { root: true });
  }
};

const mutations = {
  updateField,
  // eslint-disable-next-line no-unused-vars
  [RESET_STATE](state) {
    state = Object.assign(state, getDefaultState());
  },
  [TOGGLE_LOADING](state, toggle) {
    if (toggle == null) {
      toggle = !state.loading;
    }
    // eslint-disable-next-line no-param-reassign
    state.loading = toggle;
  }
};

const getters = {
  getField
};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: getDefaultState
};
